import { Box, SkeletonRectangle, Text } from '@wix/design-system';
import { CycleSelector as PlatformCycleSelector } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import s from './CycleSelector.scss';

interface CycleSelectorHeaderProps {
  productId: string;
}

export const CycleSelectorHeader = ({
  productId,
}: CycleSelectorHeaderProps) => {
  return (
    <PlatformCycleSelector.Card.Root padding="SP3 SP4" className={s.header}>
      <CycleSelectorHeaderContent productId={productId} />
    </PlatformCycleSelector.Card.Root>
  );
};

export const CycleSelectorHeaderContent = ({
  productId,
}: CycleSelectorHeaderProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();
  const { data: product, isLoading } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      { productId },
    );

  if (isLoading) {
    return (
      <Box align="left">
        <SkeletonRectangle height="24px" width="280px" />
      </Box>
    );
  }

  return (
    <Text weight="bold">
      {t('subscription_page.cycle_heading.title', {
        productName: product?.name,
        productId,
      })}
    </Text>
  );
};
